var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.992,
    height: 35.991,
    viewBox: "0 0 35.992 35.991",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "save_5",
    "data-name": "save 5",
    d: "M318.233,590.78H296.638a7.189,7.189,0,0,0-7.2,7.2v21.594a7.189,7.189,0,0,0,7.2,7.2h21.595a7.188,7.188,0,0,0,7.2-7.2V597.978A7.188,7.188,0,0,0,318.233,590.78Zm-10.893,29.56h-6.862a3.384,3.384,0,0,1-2.5-1.032,3.48,3.48,0,0,1-1.008-2.5v-16.2a3.462,3.462,0,0,1,3.527-3.407h6.838a1.188,1.188,0,0,1,1.2,1.2,1.2,1.2,0,0,1-1.2,1.2h-6.862a1.123,1.123,0,0,0-1.1,1.032v16.2a1.066,1.066,0,0,0,.312.792,1.11,1.11,0,0,0,.768.312h6.886a1.2,1.2,0,0,1,1.2,1.2A1.188,1.188,0,0,1,307.339,620.34Zm9.358-10.365H306.26l1.464,1.464a1.188,1.188,0,0,1,0,1.7,1.164,1.164,0,0,1-.84.36,1.217,1.217,0,0,1-.864-.36l-3.5-3.527a1.093,1.093,0,0,1-.264-.384,1.2,1.2,0,0,1,0-.911,1.1,1.1,0,0,1,.264-.384l3.5-3.527a1.2,1.2,0,1,1,1.7,1.7l-1.464,1.464H316.7a1.2,1.2,0,1,1,0,2.4Z",
    transform: "translate(-590.779 325.431) rotate(-90)",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveIcon);
export default __webpack_public_path__ + "static/media/saveIcon.4568019aca4b4e177647b2dcd50bbf88.svg";
export { ForwardRef as ReactComponent };